import type { StepConfig } from '../../types/workflow';

const pasteStep: StepConfig = {
  icon: 'copy',
  headerTextColor: '#F97316',
  headerColor: '#FFEAD5',
  title: 'Paste step',
  text: 'Paste copied step only',
  category: 'Node',
  hidden: true,
  isVirtual: true,
  virtualAction: 'pasteSingle',
  desc: 'Insert the copied step at the selected branch.',
  formFields: [],
};

export default pasteStep;
